import React from 'react'
import ReactDOM from 'react-dom'
import GarryReactComponent from './scripts/GarryReactComponent'

ReactDOM.render(<GarryReactComponent />, document.querySelector("#mdhteamwear"))